import React from 'react'
import { ToastOptions } from 'react-toastify'

import { COMMON_OPTIONS, ToastDispatcher } from './typesAndConstatnts'
import { ToastLayout } from '../ToastLayout'
import { dispatchOrUpdateToast } from './dispatchOrUpdateToast'
import SvgIcon from '../../../components/design-system/Icon/SvgIcon'
import './toast-styles.css'

const getOptions = (id?: string, customConfig?: ToastOptions): ToastOptions => ({
  ...COMMON_OPTIONS,
  style: { backgroundColor: '#ffffff' },
  progressClassName: 'progress-bar-info',
  ...customConfig,
  toastId: id
})

export const info: ToastDispatcher = ({ title, content, id, config = {} }) => {
  const layout = (
    <ToastLayout icon={<SvgIcon name="infoOutline" />} title={title} content={content} />
  )
  const options = getOptions(id, config)

  dispatchOrUpdateToast({ layout, options })
}
